<template>
  <div id="main-box">
    <div class="page-content" :class="{bottom:list.length > 0}">
      <div class="table-box layui-body" style="left:0;">

        <div class="StatusNav">
          <ul>
            <li v-for="(item,index) in navlist" v-text="item.name+'('+item.count+')'"
              :class="{'StatusNavActive':item.active}" v-on:click="NavSwitch(item.id)"></li>
          </ul>
        </div>

        <div class="xblock layui-form">
          <div class="layui-input-inline xblock-row" style="width: 150px;">
            <input type="text" name="username" placeholder="商品货号搜索" v-on:keydown.13="ProductList" v-model="sku"
              autocomplete="off" class="layui-input" />
          </div>
          <div class="layui-input-inline xblock-row" style="width: 150px;">
            <input type="text" name="username" placeholder="用户ID搜索" v-on:keydown.13="ProductList" v-model="uid"
              autocomplete="off" class="layui-input" />
          </div>
          <button class="layui-btn xblock-row" style="height: 36px;" lay-filter="sreach" v-on:click="ProductList"><i
              class="fa fa-search"></i></button>
          <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
          <div class="clear-both"></div>
        </div>

        <table class="layui-table layui-form">
          <thead>
            <tr>
              <th>图片</th>
              <th>用户</th>
              <th>公司</th>
              <th>货号</th>
              <th>标题</th>
              <th style="width: 190px;" v-if="ix == 2">站点发布状态</th>
              <th v-if="ix != 2">状态</th>
              <th v-if="ix == 3">失败原因</th>
              <th>时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody v-viewer>
            <tr v-for="(item,index) in list">
              <td>
                <div class="table_img">
                  <img :src="item.image">
                </div>
              </td>
              <td v-text="item.uid"></td>
              <td v-text="item.merchant_name"></td>
              <td v-text="item.sku"></td>
              <td>
                <i v-text="item.name"></i>
              </td>
              <td v-if="ix == 2">
                <ul class="shop-list-status">
                  <li v-for="(data,ix) in item.global_country" class="tipsBox">
                    <i v-if="data.publish_status == 'success'" class="shop-success" :class="'tips'+index+''+ix"
                      :data-pix="index" :data-ix="ix" :data-msg="'已发布'"></i>
                    <i v-else-if="data.publish_status == 'pending'" class="shop-pending" :class="'tips'+index+''+ix"
                      :data-pix="index" :data-ix="ix" :data-msg="'发布中'"></i>
                    <i v-else-if="data.publish_status == 'failed'" class="shop-failed" :class="'tips'+index+''+ix"
                      :data-pix="index" :data-ix="ix" :data-msg="data.failed_reason"></i>
                    <i v-else></i>
                    {{data.country}}
                  </li>
                </ul>
              </td>
              <td v-if="ix != 2">
                <div style="width: 80px;">
                  <i v-if="item.type == 1" class="status-box status-box-orange">待上架</i>
                  <i v-else-if="item.type == 2" class="status-box status-box-blue">上架中</i>
                  <i v-else-if="item.type == 3" class="status-box status-box-green">待发布</i>
                  <i v-else-if="item.type == 5" class="status-box status-box-blue">定时发布</i>
                  <i v-else class="status-box status-box-red">上架失败</i>
                </div>
              </td>
              <td style="min-width: 150px;max-width:400px;" v-if="ix == 3">
                <i v-if="item.error_msg" v-text="item.error_msg"></i>
                <i v-else>未知</i>
              </td>
              <td v-text="item.created_at"></td>
              <td class="btn-arr">
                <button class="layui-btn" v-on:click="OpenPage('DetailGlobal',item.id)">详情</button>
              </td>
            </tr>
          </tbody>
        </table>

        <!-- transition -->
        <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

      </div>

    </div>

    <!-- 分页 -->
    <div class="page-box">
      <div id="pagebox" class="pagebox"></div>
    </div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
  var self, form, layer, laypage, isRefresh, TimerFun;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'Global',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
    },
    data() {
      return {
        isLoding: true,
        ix: 0,
        id: null,
        itemid: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        Confirm: {
          state: false,
          txt: null
        },
        page: 1,
        count: 0,
        page_num: 20,
        isloding: false,
        list: [],
        sku: null,
        uid: null,
        navlist: [{
          id: 0,
          count: 0,
          active: false,
          name: "草稿箱",
        }, {
          id: 4,
          count: 0,
          active: false,
          name: "定时发布",
        }, {
          id: 1,
          count: 0,
          active: false,
          name: "上架中",
        }, {
          id: 2,
          count: 0,
          active: false,
          name: "待发布",
        }, {
          id: 3,
          count: 0,
          active: false,
          name: "上架失败",
        }],
        country_list: [{
          failed_reason: null,
          publish_status: false,
          country: "TW"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "ID"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "TH"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "PH"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "SG"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "VN"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "BR"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "MX"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "CL"
        }, {
          failed_reason: null,
          publish_status: false,
          country: "CO"
        }]
      }
    },
    updated() {
      if (form) {
        form.render();
      }
    },
    watch: {
      $route: {
        handler(nv, ov) {
          if (!nv.query.ix) {
            self.NavSwitch(0);
          }
        }
      },
      deep: true
    },
    beforeDestroy() {
      clearTimeout(TimerFun);
    },
    mounted() {
      self = this;
      let ix = self.$route.query.ix; //导航ID

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        if (ix) {
          self.ix = ix;
          self.NavSwitch(ix);
        } else {
          self.NavSwitch(0);
        }

        self.get_count();

        //文字提示
        var tips;
        $("#main-box").on('mouseenter', '.tipsBox', function(event) {
          let pix = $(this).find('i').attr("data-pix");
          let ix = $(this).find('i').attr("data-ix");
          let msg = $(this).find('i').attr("data-msg");
          if (msg) {
            tips = layer.tips(msg, '.tips' + pix + ix, {
              tips: 1,
              time: 999999
            });
          }
        });
        $("#main-box").on('mouseleave', '.tipsBox', function(event) {
          layer.close(tips);
        });

      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      ProductList() {
        self.list = [];
        let param = new URLSearchParams()
        if (self.sku) {
          param.append('sku', self.sku)
        }
        if (self.uid) {
          param.append('uid', self.uid)
        }
        param.append('shop_id', self.shopid)
        param.append('type', self.ix)
        param.append('num', self.page_num)
        var _url = "/get_admin_production_merchant_list/"
        self.isLoding = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + _url + '?page=' + self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(json) {
          self.isLoding = false;
          var json = json.data;
          if (json.code == 200) {
            var datas = json.datas;
            var list = datas.list;
            if (datas.page) {
              self.total = datas.total;
              for (let i in list) {
                list[i].active = false;
                var country_list = JSON.parse(JSON.stringify(self.country_list));
                if (list[i].global_country) {
                  var countrys = JSON.parse(list[i].global_country);
                  for (let x in country_list) {
                    for (let y in countrys) {
                      if (country_list[x].country == countrys[y].country) {
                        country_list[x] = countrys[y]
                      }
                    }
                  }
                }
                list[i].global_country = country_list;
              }

              self.list = list;
              self.$forceUpdate();
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "ProductList"); //分页
              $('.pagebox').show();

            }
          } else if (json.code == 401) {
            layer.alert('请先前往登录！', {
              title: "ExShopee",
              closeBtn: 0
            }, function() {
              layer.closeAll();
              self.GoToPage("/");
            });
          } else {
            self.list = [];
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.ProductList();
            }
          }
        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      get_count() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/p_get_admin_status_number_merchant/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            for (let i in self.navlist) {
              self.navlist[i].count = datas.count_arr[i]
            }
            if (datas.count_arr[2] > 0) {
              // TimerFun = setTimeout(function() {
              //   isRefresh = true;
              //   self.get_count();
              // }, 2000)
            } else {
              if (isRefresh) {
                self.ProductList();
                isRefresh = false;
              }
            }
          });

        }).catch(function(error) {
          console.log(error);
        })
      },
      NavSwitch(ix) {
        let nix;
        $('.cxall').prop('checked', false);
        self.GoToPage('/AdminGlobal?ix=' + ix); // 路由跳转
        for (let i in self.navlist) {
          self.navlist[i].active = false;
          if (self.navlist[i].id == ix) {
            nix = i;
          }
        }
        self.navlist[nix].active = true;
        self.ix = ix;
        self.list = [];
        self.ProductList();
      },
      OpenPage(url, id) {
        self.$router.push({
          path: url + '?id=' + id
        }) // 路由跳转
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }

  .shop-list-status {
    width: 190px;
    overflow: hidden;
  }

  .shop-list-status li {
    cursor: pointer;
  }

  .shop-list-status li:hover {
    opacity: 0.8;
  }

  .shop-list-status i {
    display: block;
    width: 8px;
    height: 8px;
    border-radius: 8px;
    position: absolute;
    left: 0;
    top: 8px;
    background-color: #C3C3C3;
  }

  .shop-list-status li {
    float: left;
    line-height: 25px;
    padding-left: 15px;
    position: relative;
    width: 22px;
    margin-left: 20px;
  }

  .shop-success {
    background-color: #5c7 !important;
  }

  .shop-pending {
    background-color: #f90 !important;
  }

  .shop-failed {
    background-color: #f00 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/product/Global.vue